module.exports = __webpack_public_path__ + "static/Richard-89d185f3bc7a299e65349bb325e45b11.jpg";